// rm app-engine/src/config/version.ts && ln shared/config/version.ts app-engine/src/config/version.ts && rm webapp/src/config/version.ts && ln shared/config/version.ts webapp/src/config/version.ts
export const VERSION = "2.8.15";
// ---
// v2.8.15
// Correction de bugs
// Cycle 30 :
// - [PDP] Quand on déplace de la charge, on ne déplace que sur des jours ouvrés
// - Tags/Statuts à la machine
